export default {
  Info_Control: "Thông tin đối soát",
  BtnEdit: "Sửa",
  BtnSave: "Lưu",
  BtnCancel: "Hủy",
  MerchantTitle: "Người thực hiện đối soát",
  EmailTitle: "Email nhận thông tin đối soát",
  Fullname: "Họ và tên",
  Email: "Email",
  Placeholder: {
    Email: "Nhập email nhận thông tin đối soát",
    TextTutorial: "Nhấn Enter để thêm",
  },
  PhoneNumber: "Số điện thoại",
  EmailInValid: "Email đã tồn tại",
  EmailValidateLength: "Chỉ được nhập tối đa 3 Email",
  Success: "Lưu thông tin thành công",
  EmailValidate: "Email không được để trống",
  IsSendMailTransactionSuccess: "Nhận mail thông báo giao dịch thành công",
};
